export function quoteAcceptanceMessage({ accepted = false, sent = false, totalLabel = "", datesLabel = "" } = {}) {
  const details = accepted
    ? "This quote was previously accepted and has been unlocked for editing. Accept the current dates, details and recalculated price?"
    : sent
      ? "Accept the current dates, details and recalculated price? These may differ from the quotation previously sent to the customer."
      : "Accept this quote using the current dates, details and recalculated price?";
  return `${details}${datesLabel ? `\n\nCurrent dates: ${datesLabel}` : ""}${totalLabel ? `\n\nCurrent quote total: ${totalLabel}` : ""}\n\nThe quote will be locked and the job reference updated.`;
}

// Refresh the current details before asking for approval, so the confirmed price is current.
export async function acceptCurrentQuote({ prepare, confirm, accept }) {
  const details = await prepare();
  if (!confirm(quoteAcceptanceMessage(details))) return false;
  await accept();
  return true;
}
